var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"gl-m-0 gl-list-none gl-p-0"},_vm._l((_vm.listLength),function(n){return _c('li',{key:n,staticClass:"gl-border-b gl-p-5"},[_c('loading-state-list-item',{attrs:{"left-lines-count":_vm.leftLinesCount,"right-lines-count":_vm.rightLinesCount}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }